import React, { FC, useState, Dispatch, SetStateAction } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import axios from '../../../sharedModules/utils/axios.utils';

interface CreateChillerJobModalProps {
  fetchChillerJobs: () => void;
  onImportSuccess: (orderNo: string) => void;
  createJobModalOpen: boolean;
  setCreateJobModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CreateChillerJobModal: FC<CreateChillerJobModalProps> = (props) => {
  let { fetchChillerJobs, onImportSuccess, createJobModalOpen, setCreateJobModalOpen } = props;

  let [formValues, setFormValues] = useState<{ order_no?: string }>({});
  let [errorMessage, setErrorMessage] = useState<string>('');
  let [loading, setLoading] = useState<boolean>(false);

  const handleCloseModal = () => {
    setCreateJobModalOpen(false);
    setFormValues({});
    setErrorMessage('');
    setLoading(false);
  };

  const handleFetchJob = async () => {
    setLoading(true);
    setErrorMessage('');
    try {
      await axios.post('/chiller_logs/chiller_jobs', { ...formValues });
      const orderNo = formValues.order_no || '';
      onImportSuccess(orderNo);
      handleCloseModal();
    } catch (error: any) {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('Something went wrong creating a new Chiller Job');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={createJobModalOpen}
      onClose={handleCloseModal}
      aria-labelledby="review-dialog-title"
      aria-describedby="review-dialog-description"
      fullWidth
    >
      <DialogTitle id="review-dialog-title">Import Work Order</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <TextField
              autoFocus
              label="Order No"
              type="text"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={formValues?.order_no || ''}
              onChange={(e) => setFormValues({ ...formValues, order_no: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ color: 'red', textAlign: 'left', fontSize: 14 }}>{errorMessage}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button color="primary" variant="contained" disabled={loading} onClick={handleFetchJob}>
              Fetch Servman Data
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CreateChillerJobModal;
